"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "bosco-marengo": {
    "levata": [{
      "hkey": "437a3eb6",
      "slug": "pollastra-levata",
      "name": "Pollastra-Levata",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "bosco-marengo"
    }],
    "01ad2454": [{
      "hkey": "437a3eb6",
      "slug": "pollastra-levata",
      "name": "Pollastra-Levata",
      "primary": true,
      "skipSearch": false
    }],
    "pollastra": [{
      "hkey": "437a3eb6",
      "slug": "pollastra-levata",
      "name": "Pollastra-Levata",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "bosco-marengo"
    }],
    "411e243a": [{
      "hkey": "437a3eb6",
      "slug": "pollastra-levata",
      "name": "Pollastra-Levata",
      "primary": true,
      "skipSearch": false
    }]
  }
};
exports["default"] = _default;